import { render, staticRenderFns } from "./CompetencyGridPage.vue?vue&type=template&id=7ecfc5b0"
import script from "./CompetencyGridPage.vue?vue&type=script&lang=js"
export * from "./CompetencyGridPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports